import { render, staticRenderFns } from "./ElementsHeadline.vue?vue&type=template&id=82b59490"
import script from "./ElementsHeadline.vue?vue&type=script&lang=js"
export * from "./ElementsHeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports